<template>
    <Page withNavbar>
        <Header/>
        <main>
            <div class="title">
                <h2>{{ config.DEPOSIT_TITLE }}</h2>
                <p><b>{{ config.DEPOSIT_DESCRIPTION }}</b></p>
            </div>
            <div v-if="video" class="video">
                <Video :src="video" :ratio="16/9" rounded/>
            </div>
            <div v-else class="image">
                <Picture :src="picture" :ratio="16/9" size="cover"/>
            </div>
            <div class="explanation">
                <p>
                    <b>{{ config.DEPOSIT_EXPLANATION_TITLE }}</b>
                </p>
                <ul v-if="instructions">
                    <li v-for="(instruction, index) in instructions" :key="index" :style="configStyles.primary.text">
                        <span>{{ instruction }}</span>
                    </li>
                </ul>
                <p>{{ config.DEPOSIT_EXPLANATION_PS }}</p>
            </div>
            <div class="actions">
                <Button :color="config.COLOR_PRIMARY" outline :to="{ name: nextPostpone }">
                    {{ config.DEPOSIT_EXPLANATION_POSTPONE }}
                </Button>
                <Button :color="config.COLOR_PRIMARY" :to="{ name: nextUpload }">
                    {{ config.DEPOSIT_EXPLANATION_UPLOAD }}
                </Button>
            </div>
        </main>
        <transition name="fade">
            <keep-alive>
                <router-view/>
            </keep-alive>
        </transition>
    </Page>
</template>
<script>
import { SolutionConsumer, CastingConsumer } from '@skeepers/platform-framework/mixins';
import { Page, Header } from '@skeepers/platform-framework/components/desktop';
import { parseJsonOrNull } from '@skeepers/platform-framework/utils';

export default {
    name: 'Deposit',
    components: { Page, Header },
    mixins: [SolutionConsumer, CastingConsumer],
    computed: {
        video () {
            return this.config.DEPOSIT_EXPLANATION_VIDEO;
        },
        picture () {
            return this.config.DEPOSIT_EXPLANATION_IMAGE || this.config.DEPOSIT_EXPLANATION_IMAGE_MOBILE;
        },
        instructions () {
            return parseJsonOrNull(this.config.DEPOSIT_EXPLANATION_INSTRUCTIONS);
        },
        nextPostpone () {
            return this.application.progress === 'UPLOAD' ? 'deposit.complete' : 'deposit.postpone';
        },
        nextUpload () {
            return this.application.progress === 'UPLOAD' ? 'deposit.complete' : this.$route.query.next || 'deposit.upload';
        },
    },
};
</script>
<style lang="scss" scoped>
@import '~@skeepers/platform-framework/assets/scss/mixins';
@import '~@skeepers/platform-framework/assets/scss/colors';

main {
    @include brief-section-grid();

    > .title {
        text-align: center;
    }

    > .image {
        box-shadow: 6px 6px 12px 0 rgba($black, .1);
        border-radius: 12px;
        overflow: hidden;
        align-self: flex-start;
    }

    > .video {
        align-self: flex-start;
    }

    > .explanation {
        > ul {
            padding: 0 0 0 20px;
            margin: 20px 0;

            > li {
                line-height: 2;

                > span {
                    color: $grey-light;
                }
            }
        }
    }

    > .actions {
        display: flex;
        align-items: center;
        justify-content: center;

        button {
            margin: 0 20px;
        }
    }

    @include breakpoint-min(lg) {
        > .title {
            grid-column: 1 / 3;
        }

        > .actions {
            grid-column: 1 / 3;
        }
    }

}
</style>
